<li
  *ngIf="isAnyImportedFromABBV2"
  matTooltip="Re-import selected bookings from Airbnb."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="import.emit(true)" type="button"><i class="fal fa-cloud-download"></i> Re-import</button>
</li>
<!-- Link -->
<li
  matTooltip="Link multiple related inquiries together. This allows them to share the same data."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="link.emit(true)" type="button"><i class="fal fa-link"></i> Link</button>
</li>

<li class="dropdown-divider"></li>

<!-- Paid -->
<li
  *ngIf="isAnyUnpaid"
  matTooltip="Mark selected bookings as paid."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="paid.emit(true)" type="button"><i class="fal fa-money-check-alt"></i> Mark as paid</button>
</li>

<!-- Unpaid -->
<li
  *ngIf="!isAnyUnpaid"
  matTooltip="Mark selected bookings as unpaid."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="unpaid.emit(true)" type="button"><i class="fal fa-money-check-alt"></i> Mark as unpaid</button>
</li>

<li class="dropdown-divider"></li>

<!-- Archive -->
<li
  *ngIf="isAnyUnArchived"
  matTooltip="Archive inquiries and hide them from the default view."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="archive.emit(true)" type="button"><i class="fal fa-archive"></i> Archive</button>
</li>

<!-- Unarchive -->
<li
  *ngIf="!isAnyUnArchived"
  matTooltip="Unarchive previously archived inquiries."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="unarchive.emit(true)" type="button"><i class="fal fa-file-archive"></i> Unarchive</button>
</li>

<li class="dropdown-divider"></li>

<!-- Mark for followup -->
<li
  *ngIf="isAnyNoFollow"
  matTooltip="Flag selected inquiries for follow-up later."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="followup.emit(true)" type="button"><i class="fas fa-star"></i> Mark for followup</button>
</li>

<!-- Mark for no followup -->
<li
  *ngIf="!isAnyNoFollow"
  matTooltip="Remove follow-up flag from selected inquiries."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="nofollowup.emit(true)" type="button"><i class="fal fa-star"></i> Mark for no followup</button>
</li>

<li class="dropdown-divider"></li>

<!-- Mark as read -->
<li
  *ngIf="isAnyUnRead"
  matTooltip="Mark selected inquiries as read."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="read.emit(true)" type="button"><i class="fal fa-envelope-open"></i> Mark as read</button>
</li>

<!-- Mark as unread -->
<li
  *ngIf="!isAnyUnRead"
  matTooltip="Mark selected inquiries as unread."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="unread.emit(true)" type="button"><i class="fal fa-envelope"></i> Mark as unread</button>
</li>

<li class="dropdown-divider"></li>

<!-- Add tags -->
<li matTooltip="Add tags to selected inquiries" matTooltipClass="text-center" matTooltipPosition="left">
  <button (click)="tags.emit(true)" type="button"><i class="fal fa-tags"></i> Add Tags</button>
</li>

<li class="dropdown-divider"></li>

<!-- Edit Columns -->
<li
  *ngIf="hasColumns"
  matTooltip="Edit the order of columns on this table."
  matTooltipClass="text-center"
  matTooltipPosition="left"
>
  <button (click)="columns.emit(true)" type="button"><i class="fal fa-columns"></i> Edit Columns</button>
</li>

<li *ngIf="hasColumns" class="dropdown-divider"></li>

<!-- Delete -->
<li matTooltip="Delete selected inquiries and bookings." matTooltipClass="text-center" matTooltipPosition="left">
  <button (click)="delete.emit(true)" type="button"><i class="fal fa-trash-alt"></i> Delete</button>
</li>
